import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFloppyDisk1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="floppy-disk-1, save"><path d="M3.75 3.75H17.25L20.25 6.75V20.25H3.75V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M7.75 20.25V12.75H16.25V20.25H7.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M7.75 3.75V8.25H16.25V3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFloppyDisk1;
